import {basePath} from "../constants/public-routes";

export default {
  locale: "de",

  messages: {
    "about": "über diese Website",
    "aboutMenu": "Über",
    "aboutThisText": "Über diesen Tekst",
    "addedtoPrint": "Ausdruck hinzugefügt",
    "addPrint": "Ausdruck hinzufügen",
    "advancedSearch": "Erweiterte Suche",
    "advancedSearching": "Meer zoekopties (D)",
    "alsoLookedFor": "Es wurde auch gesucht nach",
    "annotatedTexts": "Gesetzestexte",
    "toTheAnnotatedTexts": "zu den Gesetzestexten",
    "annotation": "erläuternden Anmerkungen",
    "annotationOf": "erläuternde Anmerkung zu",
    "annotations": "erläuternden Anmerkungen",
    "annotationsBack": "nach erläuternden Anmerkungen",
    "annotationsOf": "erläuternde Anmerkungen zu",
    "anyQuestions": "Haben Sie Fragen oder Anmerkungen? Übermitteln Sie uns diese mittels das Kontaktformulars.",
    "arrest": "Rechtsprechung und Stellungnahmen",
    "arrests": "Rechtsprechung und Stellungnahmen",
    "article": "Artikel",
    "articleNumber": "Artikelnummer",
    "author": "Urheber",
    "back": "Zurück",
    "backToLastSearch": "letzte Suche wiederholen",
    "backToPrevious": "Zurück",
    "belgianSenate": "Belgischer Senat",
    "changeDate": "Datum der Änderung",
    "clear": "Löschen",
    "clearOptions": "Optionen löschen",
    "comment": "Erläuterung",
    "comments": "Erläuterungen",
    "contact": "Kontakt",
    "currentLanguage": "Konsultierte Sprache",
    "currentVersion": "Konsultierte Version",
    "dateAnnounced": "Veröffentlichung",
    "dateConfirmed": "Sanktionierung",
    "dateEffective": "Inkrafttreten",
    "dateVersion": "Version",
    "de": "Deutsch",
    "dia": "SenLex",
    "diaIntro": "<p>Die Datenbank SenLex ist eine Sammlung amtlicher Auskünften bezüglich sämtlicher belgischen Institutionsregeln. Die Datenbank hat für Sie die Verfassung und die wichtigsten institutionellen Normen gesammelt und je Artikel sortiert, aussagekräftige Auszüge aus der parlamentarischen Vorbereitung, der Rechtsprechung des Verfassungsgerichts und Gutachten des Staatsrates aufgeführt. Dort können Sie Texte der institutionellen Verordnungen abrufen, und zwar in der Form, in der sie zum Zeitpunkt des Inkrafttretens der sechsten Staatsreform am 1. Juli 2014 bestanden, einschließlich der späteren Änderungen.</p><p><a href='de/about'>Mehr erfahren</a>.</p>",
    "differentLanguages": "Andere Sprachen",
    "dutch": "Niederländisch",
    "effectiveDate": "Datum des Inkrafttretens",
    "element": "Element",
    "Email": "E-Mail",
    "findThis": "Zoek hiernaar (D)",
    "firstArticle": "erster Artikel",
    "foundCategory": "Categorie (D)",
    "foundTag": "Stichwort",
    "fr": "Französisch",
    "french": "Französisch",
    "from": "aus",
    "german": "Deutsch",
    "hideAdvancedSearching": "Verberg zoekopties (D)",
    "history": "Verlauf der Abänderungen",
    "home": "Home",
    "indexBack": "Zum Index",
    "language": "Sprache",
    "lastArticle": "letzter Artikel",
    "law": "Gesetz",
    "lawTexts": "Gesetzetexte",
    "message": "Ihre Frage oder Bemerkung",
    "Message": "Mitteilung",
    "Name": "Name",
    "next": "nächste Seite",
    "nl": "Niederländisch",
    "noStructureLabel": "[Basiswet] (D)",
    "noVersions": "Es gibt momentan kein andere Versionen",
    "onlyOneArticleVersion": "Dit artikel is niet gewijzigd sedert de start van SenLex (DE)",
    "noXFound": "kein {subject} gefunden",
    "or": "oder",
    "otherVersions": "Versionen",
    "overview": "Übersicht",
    "pref": "Parlamentarische Vorbereitung",
    "prefs": "Parlamentarische Vorbereitung",
    "previous": "vorherige Seite",
    "previousVersions": "vorherige Version",
    "print": "Drucken",
    "printQueue": "Druckliste",
    "publication": "Veröffentlichung",
    "query": "Zoekopdracht (D)",
    "quoteTip": "Das System sucht nach dem genauen Wort oder der genauen Wortkombination..<br/>Die folgenden Wildcards können verwendet werden.:<br/>" +
    "- \"?\" : ersetzt ein Zeichen.<br/>" +
    "- \"*\" : ersetzt 0, ein oder mehrere Zeichen.",
    "read": "Lesen",
    "readOn": "mehr erfahren",
    "recentChanges": "Recente wijzigingen",
    "ref": "Siehe auch",
    "refs": "Siehe auch",
    "relevant": "Relevante Vorschriften",
    "search": "Suchen",
    "searchResults": "Ergebnisse",
    "searchTerm": "Wörter im Text",
    "send message": "Nachricht senden",
    "show message": "Nachricht zeigen",
    "Senlex": "Senlex",
    "showingXofY": "{start, number} - {end, number}",
    "showLess": "weniger",
    "showMore": "mehr",
    "simpleSearch": "Eenvoudig zoeken (D)",
    "source": "Quelle",
    "stay-informed-latest": "Bleiben Sie immer auf dem Laufenden mit unseren RSS-Feeds.",
    "structure": "Gesetzestext",
    "subject": "Thema",
    "Subject": "Betrifft",
    "tableOfContents": "Inhaltsverzeichnis",
    "tagIndex": "zum Stichwortverzeichnis",
    "tags": "Stichwörter",
    "text": "Text",
    "tooManyResults": "Er zijn heel veel resultaten gevonden, waardoor mogelijks niet alle resultaten kunnen getoond worden. Gelieve de filters te verstrengen. (DE)",
    "type": "Informationstypen",
    "typeSearch": "Geben Sie hier Ihren Suchbegriff ein",
    "typeTags": "Geben Sie hier ein oder mehrere Stichwörter ein",
    "weWillAnswer": "Die Mitarbeiter von SenLex versuchen so schnell wie möglich eine Antwort zu senden.",
    "your email adress": "Ihre e-Mail Adresse"
  }
};



/** WEBPACK FOOTER **
 ** ./src/i18n/de.js
 **/